import { render, staticRenderFns } from "./dashboardObjetivos.vue?vue&type=template&id=75e872da&"
import script from "./dashboardObjetivos.vue?vue&type=script&lang=js&"
export * from "./dashboardObjetivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports